import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
	catchError,
	distinctUntilChanged,
	EMPTY,
	Observable,
	shareReplay,
	switchMap,
	timer
} from "rxjs";
import { environment } from "../../../../environments/environment";

export const MAINTENANCE_POLLING_INTERVAL_MS = 60_000;

@Injectable({
	providedIn: "root"
})
export class MaintenanceService {
	private readonly http = inject(HttpClient);

	private readonly maintenanceFlagUrl = environment.apiDemandUrl + "/feature-flags/maintenance";

	readonly isUnderMaintenance$: Observable<boolean> = timer(
		0,
		MAINTENANCE_POLLING_INTERVAL_MS
	).pipe(
		switchMap(() => this.http.get<boolean>(this.maintenanceFlagUrl).pipe(catchError(() => EMPTY))),
		distinctUntilChanged(),
		shareReplay({ bufferSize: 1, refCount: true })
	);
}
